<script>
  import Pictureframe from './pictureframe/pictureframe.svelte'
  export let data
</script>

<div class="varmelding-wrapper">
  {#each data as entry, index}
    <div class="varmelding-picture-wrapper order-{index + 1}">
      <Pictureframe
        data={entry}
        showText={index + 1 === data.length}
        leanTowards={index % 2 === 0 ? 'left' : 'right'}
      />
    </div>
  {/each}
</div>

<style>
  .varmelding-picture-wrapper {
    width: 90%;
  }
  .varmelding-picture-wrapper.order-2 {
    margin-top: -250px;
    margin-left: 145px;
  }
</style>
